<template>
    <CardPage :section="1" :page="2" :audio="true">
        <p>
            In this LifeSkills app, you’ll have a chance to share things about yourself and to learn some new things, too.
        </p>
        <p>
            Here’s how it’ll work: You get a sticker every time you finish an activity. You get a trophy when you finish a whole set of activities! Not that
            size matters, but the trophies get bigger and bigger as you finish more levels 😀 Get yours!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section2/sticker')
    }
};
</script>
